<template>
  <div id="CheckGid">
    <div v-if="ActiveManageShow" class="well" style="padding: 0 1em">
      <div style="text-align: left; padding: 0.5rem 2rem">
        <div>
          <button
            href="#"
            @click="AddActive()"
            class="btn btn-outline-success"
            type="button"
            style="font-size: 14px; text-align: right"
          >
            新增高中職招生宣導活動
          </button>
          目前高中職招生宣導活動共 {{ total }}筆
        </div>

        <div style="display: flex">
          <div style="margin-right: 10px">
            活動開始日期：<br />
            <flat-pickr
              v-model="queryInfo.sActiveTime"
              :config="flatpickrConfig"
              ref="flatpickrInstance"
            ></flat-pickr>
          </div>

          <div>
            活動結束日期：<br />
            <flat-pickr
              v-model="queryInfo.eActiveTime"
              :config="flatpickrConfig"
              ref="flatpickrInstance"
            ></flat-pickr>
          </div>
          <div>
            學校名稱：<br />
            <input
              type="text"
              class="form-control"
              v-model="queryInfo.schoolName"
              placeholder="學校名稱"
            />
          </div>
          <div>
            招生類型：<br />
            <input
              type="text"
              class="form-control"
              v-model="queryInfo.enrollTypeName"
              placeholder="招生類型"
            />
          </div>
          <!-- <div>
            系名稱：<br />
            <input
              type="text"
              class="form-control"
              v-model="queryInfo.dptcdName"
              placeholder="系名稱"
            />
          </div>
          <div>
            學院名稱：<br />
            <input
              type="text"
              class="form-control"
              v-model="queryInfo.gidName"
              placeholder="學院名稱"
            />
          </div>
          <div>
            宣導人員：<br />
            <input
              type="text"
              class="form-control"
              v-model="queryInfo.updateUserName"
              placeholder="宣導人員"
            />
          </div> -->
          <button
                    href="#"
                    @click.prevent="getActivity()"
                    class="btn btn-outline-info"
                    type="button"
                    style="font-size: 14px"
                  >
                    查詢
                  </button>
        </div>
      </div>

      <b-tabs content-class="mt-3" justified>
        <div
          class="dataTables_scrollBody"
          style="
            font-size: 14px;
            position: relative;
            overflow: auto;
            max-height: 100%;

            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          <b-table-simple
            class="ncut-table-menu-striped ncut-table-menu"
            responsive
            bgcolor="#FFFFFF"
          >
            <b-thead class="ncut-thead-menu">
              <b-tr>
                <b-th style="min-width: 2em">序號</b-th>
                <b-th style="min-width: 3em">地區</b-th>
                <b-th style="min-width: 3em">活動名稱</b-th>
                <b-th style="min-width: 3em">招生類型</b-th>
                <b-th style="min-width: 5em">活動開始時間</b-th>
                <b-th style="min-width: 5em">活動結束時間</b-th>
                <b-th style="min-width: 2em">本活動小組長</b-th>
                <b-th style="min-width: 2em">本活動宣導人數(名額/已報名)</b-th>

                <b-th style="min-width: 20em">管理</b-th>
              </b-tr>
            </b-thead>
            <b-tbody class="ncut-tbody-menu">
              <b-tr
                v-for="(item, index) in filteredDocs"
                :key="item.aid"
                :index="item.aid"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <b-td style="text-align: right">
                  {{ (currentPage - 1) * pageSize + index + 1 }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.city }}
                </b-td>
                <b-td style="text-align: left">{{ item.activeName }}</b-td>
                <b-td style="text-align: left">{{ item.typeName }}</b-td>
                <b-td style="text-align: left">{{ item.sActiveTime }}</b-td>
                <b-td style="text-align: left">{{ item.eActiveTime }}</b-td>
                <b-td style="text-align: left">{{ item.name }}</b-td>
                <b-td style="text-align: left"
                  >{{ item.activeNumber }} / {{ item.signUpTotal }}</b-td
                >

                <b-td v-if="item.signUpTotal == 0">
                  <button
                    href="#"
                    @click.prevent="EditActive(item.aid,item.sn)"
                    class="btn btn-outline-info"
                    type="button"
                    style="font-size: 14px"
                  >
                    修改
                  </button>

                  <button
                    href="#"
                    @click.prevent="remove(item.aid)"
                    class="btn btn-outline-danger"
                    type="button"
                    style="font-size: 14px"
                  >
                    刪除
                  </button>
                </b-td>
                <b-td v-else>

                  <button
                    href="#"
                    @click.prevent="remove(item.aid)"
                    class="btn btn-outline-danger"
                    type="button"
                    style="font-size: 14px"
                  >
                    刪除
                  </button>
                </b-td>


              </b-tr>
            </b-tbody>
          </b-table-simple>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            :limit="21"
            v-if="total > pageSize"
          />
        </div>
      </b-tabs>

      <b-modal size="xl" ref="ListActiveDetailVa2" hide-footer>
        <template #modal-title> 高中職宣導活動詳細 </template>
        <ListActiveDetailVa2
          :aid="aid"
          :sn="sn"
          @hideModal="hideModal('ListActiveDetailVa2')"
        ></ListActiveDetailVa2>
      </b-modal>
      <b-modal size="xl" ref="AddActive" hide-footer>
        <template #modal-title> 新增高中職宣導活動 </template>
        <AddActive
          :inputData3="localInputData3"
          :orglocalInputData3="orglocalInputData3"
          @hideModal="hideModal('AddActive')"
        >
        </AddActive>
      </b-modal>
      <b-modal size="xl" ref="EditActive" hide-footer>
        <template #modal-title> 修改高中職宣導活動 </template>
        <EditActive
          :aid="aid"
          :sn="sn"
          :inputData3="localInputData3"
          :orglocalInputData3="orglocalInputData3"
          @hideModal="hideModal('EditActive')"
        ></EditActive>
      </b-modal>
      <b-modal ref="q-modal" hide-footer title="請注意">
        <div class="d-block text-center">
          <h3>是否確認刪除此筆資料(包含此高中職宣導活動和學員參加報名資訊)?</h3>
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="cancalRM"
          >取消刪除</b-button
        >
        <b-button class="mt-2" variant="outline-info" block @click="confirmRM"
          >刪除確認</b-button
        >
      </b-modal>
    </div>

    <div v-else class="well" style="padding: 0 1em">
      <div style="text-align: left; padding: 0.5rem 2rem">
        <button
          href="#"
          @click.prevent="backActiveList()"
          class="btn btn-outline-secondary"
          type="button"
          style="font-size: 14px"
        >
          回活動列表
        </button>
      </div>
      <br />
      <div style="font-size: 20px; text-align: left; padding: 0.5rem 2rem">
        活動編號 {{ aid }} {{ activeName }}報名清單共{{ total2 }}筆
      </div>

      <b-tabs content-class="mt-3" justified>
        <div
          class="dataTables_scrollBody"
          style="
            font-size: 14px;
            position: relative;
            overflow: auto;
            max-height: 100%;

            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          <b-table-simple
            class="ncut-table-menu-striped ncut-table-menu"
            fixed
            responsive
            bgcolor="#FFFFFF"
          >
            <b-thead class="ncut-thead-menu">
              <b-tr>
                <b-th style="min-width: 1em">序號</b-th>
                <b-th style="min-width: 5em">報名者</b-th>
                <b-th style="min-width: 5em">報名時間</b-th>
                <b-th style="min-width: 5em">職稱</b-th>
                <b-th style="min-width: 2em">單位</b-th>
                <b-th style="min-width: 2em">email</b-th>
                <b-th style="min-width: 2em">審核狀態</b-th>
              </b-tr>
            </b-thead>
            <b-tbody class="ncut-tbody-menu">
              <b-tr
                v-for="(item, index) in filteredDocs2"
                :key="item.empCode"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <b-td style="text-align: right">
                  {{ (currentPage2 - 1) * pageSize + index + 1 }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.userCN }}
                </b-td>
                <b-td style="text-align: left">
                  {{ getToday(item.updateTime) }}
                </b-td>
                <b-td style="text-align: left">{{ item.jobTitle }}</b-td>

                <b-td style="text-align: left">{{ item.deptName }}</b-td>
                <b-td style="text-align: left">{{ item.email }}</b-td>
                <b-td style="text-align: left">報名成功</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <b-pagination
            v-model="currentPage2"
            :total-rows="total"
            :per-page="pageSize"
            v-if="total > pageSize"
          />
        </div>
      </b-tabs>
    </div>
  </div>
</template>


<script>
import ListActiveDetailVa2 from "@/components/ListActiveDetailVa2.vue";
import AddActive from "@/components/AddActive.vue";
import EditActive from "@/components/EditActive.vue";
import * as tools from "../tool";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { tw } from "flatpickr/dist/l10n/zh-tw.js";
export default {
  name: "CheckGid",
  data() {
    return {
      ClassEnable: false,
      ForumEnable: false,
      ActiveName: null,
      selectedDateTime: null,
      TimeOpenShow: false,
      ActiveManageShow: false,
      cid: null,
      aid: null,
      sn: null,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected: null,
      editId: 0,
      over: 0,
      total: 0,
      total2: 0,
      isIE: false,
      inputData: {
        sActiveTime: null,
        eActiveTime: null,
      },
      inputData2: null,
      flatpickrConfig: {
        allowInput: true, // 允許手動輸入
        clear: true,      // 顯示清除按鈕
        //defaultDate: null, // 清除當前選擇的日期
        enableTime: false,
        weekNumbers: true,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "Y-m-d",
        time_24hr: false, // 這應該強制使用 12 小時制
        locale: {
          weekdays: {
            shorthand: ["日", "一", "二", "三", "四", "五", "六"],
            longhand: [
              "星期日",
              "星期一",
              "星期二",
              "星期三",
              "星期四",
              "星期五",
              "星期六",
            ],
          },
        },
      },
      inputData3: null,
      orglocalInputData3: null,
      localInputData3: null,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10,
      queryInfo: {
        sActiveTime: null,
        eActiveTime: null,
        schoolName: null,
        dptcdName: null,
        gidName: null,
        updateUserName:null,
        enrollTypeName:null,
      },
    };
  },
  components: {
    ListActiveDetailVa2,
    AddActive,
    EditActive,
    flatPickr,
  },
  methods: {
    getActivity() {
      let vm = this;
      if (vm.queryInfo.sActiveTime != null)
      {
        const dateObject = new Date(vm.queryInfo.sActiveTime);
// 提取日期部分
vm.queryInfo.sActiveTime = dateObject.toISOString().split('T')[0];
      }
      if (vm.queryInfo.eActiveTime != null)
      {
        const dateObject = new Date(vm.queryInfo.eActiveTime);
// 提取日期部分
vm.queryInfo.eActiveTime = dateObject.toISOString().split('T')[0];
      }

      this.$http
      .put("./WebApi/HighSchoolEnrolling/GetActivity/", vm.queryInfo)
      .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;
            console.log("vm.inputData", vm.inputData);
          if (vm.inputData.length != null) vm.total = vm.inputData.length;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    getToday(updateTime) {
      var dd = new Date(updateTime);
      var day = dd.getDate().toString().padStart(2, "0"); //內建getDate 取到目前年月日
      var month = (dd.getMonth() + 1).toString().padStart(2, "0"); //January is 0!
      var year = dd.getFullYear();
      var hh = dd.getHours();
      var mm = dd.getMinutes();
      return year + "年" + month + "月" + day + "日" + hh + "時" + mm + "分";
      // return tools.stringFormat("{0}-{1}-{2}", yyyy, mm, today);
    },

    backActiveList() {
      this.ActiveManageShow = true;
      this.getALLActiveList();
    },
    getSignUpList(aid) {
      let vm = this;

      this.$http
        .get("./WebApi/HighSchoolEnrolling/GetSignUpList/".concat(aid))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData2 = response.data;

            if (vm.inputData2.length != null) vm.total2 = vm.inputData2.length;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    signUpManage(aid) {

      this.aid = aid;
      const matchingOption = this.inputData.find((option) => option.aid == aid);
      if (matchingOption) {
        this.activeName = matchingOption.activeName;
      }

      this.getSignUpList(aid);
      this.ActiveManageShow = false;
    },

    getAllSchoolName() {
      let vm = this;
      this.$http
        .get("./WebApi/HighSchoolEnrolling/GetAllSchoolName/")
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.orglocalInputData3 = response.data;

            // 使用Set物件來儲存不重複的CID
            const uniqueCids = new Set();

            // 過濾掉重複的CID，並存放到localInputData3中
            vm.localInputData3 = vm.orglocalInputData3.filter((item) => {
              if (!uniqueCids.has(item.cid)) {
                uniqueCids.add(item.cid);
                return true;
              }
              return false;
            });
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
        });
    },

    getALLActiveList() {
      let vm = this;

      this.$http
        .get(
          "./WebApi/HighSchoolEnrolling/GetALLActiveList/".concat(
            "0" + "/" + "0"
          )
        )
        .then((response) => {
          if (!tools.isNull(response) && response.data.length > 0) {
            vm.inputData = response.data;
            //console.log("vm.inputData", vm.inputData);
            vm.total = vm.inputData.length;

            var date1 = new Date(vm.inputData[0].sdateTime);
            var date2 = new Date(vm.inputData[0].edateTime);

            // 取得現在的時間
            var now = new Date();

            // 進行比較
            if (now >= date1 && now <= date2) {
              vm.TimeOpenShow = true;
            } else {
              vm.TimeOpenShow = false;
            }
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    checkGid() {
      let vm = this;

      this.$http
        .get(
          "./WebApi/HighSchoolEnrolling/CheckGid/")
        .then((response) => {
          if (!tools.isNull(response) && response.data.length > 0) {
            vm.inputData = response.data;
            //console.log("vm.inputData", vm.inputData);



          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    AddActive() {
      var vm = this;
      vm.$refs["AddActive"].show();
    },
    EditActive(aid, sn) {
      var vm = this;
      vm.aid = aid;
      vm.sn = sn;
      vm.checkClassEnable();
      vm.$refs["EditActive"].show();
    },
    checkClassEnable() {
      if (this.sn == 14 || this.sn == 15 || this.sn == 16) {
        this.ClassEnable = true;
      }
      if (this.sn == 7) {
        this.ForumEnable = true;
      }
    },
    ListActiveDetailVa2(aid, sn) {
      var vm = this;
      vm.aid = aid;
      vm.sn = sn;
      vm.$refs["ListActiveDetailVa2"].show();
    },

    remove(aid) {
      this.aid = aid;
      this.$refs["q-modal"].show();
    },
    cancalRM() {
      this.$refs["q-modal"].hide();
    },
    hideModal(name) {
      this.$refs[name].hide();
      this.getALLActiveList();
    },
    confirmRM() {
      //刪除高中職宣導活動資料
      this.$refs["q-modal"].hide();
      var vm = this;
      this.$http
        .get("./WebApi/HighSchoolEnrolling/DeleteActive/".concat(this.aid))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, "success", "恭喜您,刪除成功");
            vm.getALLActiveList();
          } else {
            tools.showAlert(vm, "danger", "對不起,刪除失敗");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });
    },
  },
  computed: {
    //   filters: {
    //   dateFormat: function (input) {
    //     var d = new Date(input)
    //     var year = d.getFullYear()
    //     var month = d.getMonth() + 1
    //     var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
    //     var hh = d.getHours()
    //     var ss = d.getMinutes()
    //     return year + '年' + month + '月' + day + '日' + hh + '時' + ss + '分'
    //   }
    // },
    filteredDocs: function () {
      let data = [];
      data = Array.isArray(this.inputData)
        ? this.inputData.slice(
            (this.currentPage - 1) * this.pageSize,
            this.currentPage * this.pageSize
          )
        : [];
      return data;
    },
    filteredDocs2: function () {
      let data = [];
      if (this.inputData2 != null) {
        data = this.inputData2.slice(
          (this.currentPage2 - 1) * this.pageSize,
          this.currentPage2 * this.pageSize
        );
      }
      return data;
    },

    headerColor() {
      return "#f7e8aa";
    },
  },
  created() {
    console.log("======created CheckGidView =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    let vm = this;

    vm.ActiveManageShow = true;
    vm.getALLActiveList();
    vm.getAllSchoolName();
    vm.checkGid();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
